module.exports = __webpack_public_path__ + "img/shopGuide1-b.23f952c0.jpg";